import { ensureElement } from "../utils/utils";
import { Component } from "./base/Component";
export class Basket extends Component {
    constructor(container, events) {
        super(container);
        this._list = ensureElement('.basket__list', this.container);
        this._total = ensureElement('.basket__price', this.container);
        this._button = ensureElement('.basket__button', this.container);
        this._button.addEventListener('click', () => {
            events.emit('basket:submit');
        });
    }
    set total(value) {
        this.setText(this._total, String(`${value} синапсов`));
    }
    set list(items) {
        this._list.replaceChildren(...items);
    }
    setSubmitDisabled(state) {
        this._button.disabled = state;
    }
}
